import { render, staticRenderFns } from "./CrudHighlightsAwards.vue?vue&type=template&id=4f1b88d5&scoped=true"
import script from "./CrudHighlightsAwards.vue?vue&type=script&lang=ts"
export * from "./CrudHighlightsAwards.vue?vue&type=script&lang=ts"
import style0 from "./CrudHighlightsAwards.vue?vue&type=style&index=0&id=4f1b88d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1b88d5",
  null
  
)

export default component.exports